
import { axios } from '@/utils/request'

const api = {
  options: '/wyhadminapi/kaoguan/options',
  kaoguanManageList: '/wyhadminapi/kaoguan/kaoguanManageList',
  manageDetail: '/wyhadminapi/kaoguan/manageDetail',
  editManage: '/wyhadminapi/kaoguan/editManage',
  memberList: '/wyhadminapi/kaoguan/memberList',
  memberDetail: '/wyhadminapi/kaoguan/memberDetail',
  memberEdit: '/wyhadminapi/kaoguan/memberEdit',
  manageDelete: '/wyhadminapi/kaoguan/manageDelete',
  memberDelete: '/wyhadminapi/kaoguan/memberDelete',
}

export default api

export function getOptions(parameter) {
  return axios({
    url: api.options,
    method: 'get',
    params: parameter
  })
}

export function kaoguanManageList(parameter) {
  return axios({
    url: api.kaoguanManageList,
    method: 'get',
    params: parameter
  })
}
export function manageDetail(parameter) {
  return axios({
    url: api.manageDetail,
    method: 'get',
    params: parameter
  })
}

export function editManage(parameter) {
  return axios({
    url: api.editManage,
    method: 'post',
    data: parameter
  })
}

export function getApplyMemberList(parameter) {
  return axios({
    url: api.memberList,
    method: 'post',
    data: parameter
  })
}
export function memberEdit(parameter) {
  return axios({
    url: api.memberEdit,
    method: 'post',
    data: parameter
  })
}

export function memberDetail(parameter) {
  return axios({
    url: api.memberDetail,
    method: 'get',
    params: parameter
  })
}

export function applyDelete(parameter) {
  return axios({
    url: api.manageDelete,
    method: 'get',
    params: parameter
  })
}

export function memberDelete(parameter) {
  return axios({
    url: api.memberDelete,
    method: 'get',
    params: parameter
  })
}
